import { ca } from '@cian/analytics';

export const VIEWED_TIMEOUT = 1000;

export enum EBlockName {
  Address = 'show_address_form',
}

export const trackBlockVeiwed = (name: EBlockName) => {
  ca('teaser', {
    product: {
      name,
    },
  });
};

export const trackAddressForm = () => trackBlockVeiwed(EBlockName.Address);
